'use client';

import { AppsPath, MyConnectionsPath } from '@/src/lib/paths';
import { redirect } from 'next/navigation';
import { MeContext } from '../../../providers/Me';
import { useContext } from 'react';
import { BillingFeatureId, UserRole } from '../../../../__generated__/graphql';

export default function TenantPage() {
  const { currentOrg, currentUser } = useContext(MeContext);
  if (currentOrg?.enabledFeatures?.includes(BillingFeatureId.AiIdentity)) {
    // if admin, redirect to the /apps page
    if (currentUser?.role === UserRole.Admin) {
      return redirect(AppsPath);
    } else {
      // otherwise, go to my connections page
      return redirect(MyConnectionsPath);
    }
  }
  return redirect(MyConnectionsPath);
}
